export default __webpack_public_path__ + "static/media/cursor_button.22412fc3.svg";